/**
 * Component: Product Full Width
 */

import { gsap } from 'gsap/dist/gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class ProductFullWidth {
    constructor() {
        // selectors
        this.selectors = {
            trigger: '[data-in-view="trigger"]',
            targets: '[data-in-view="target"]'
        };

        if (!document.querySelector(this.selectors.trigger) && !document.querySelector(this.selectors.targets)) return;

        this.scrollTriggerAnimation();
    }

    scrollTriggerAnimation() {
        ScrollTrigger.batch(this.selectors.trigger, {
            onEnter: (elements) => {
                elements.forEach((el) => {
                    // Stagger animation for the individual bubbles
                    gsap.from(el.querySelectorAll(this.selectors.targets), {
                        duration: 0.8,
                        y: 20,
                        scale: 0,
                        stagger: 0.3
                        // eslint-disable-next-line
                        // ease: CustomEase.create('custom', 'M0,0 C0,0 0.086,0.012 0.14,0.092 0.19,0.166 0.258,0.279 0.29,0.364 0.318,0.438 0.341,0.497 0.376,0.57 0.408,0.638 0.439,0.689 0.495,0.744 0.543,0.793 0.575,0.822 0.63,0.863 0.672,0.895 0.702,0.913 0.75,0.937 0.793,0.959 0.823,0.971 0.87,0.983 0.917,0.994 1,1 1,1'),
                    });

                    // Opacity is animates slower than the rest of the properties
                    gsap.from(el.querySelectorAll(this.selectors.targets), {
                        duration: 1.8,
                        autoAlpha: 0,
                        stagger: 0.3
                        // eslint-disable-next-line
                        // ease: CustomEase.create('custom', 'M0,0 C0,0 0.086,0.012 0.14,0.092 0.19,0.166 0.258,0.279 0.29,0.364 0.318,0.438 0.341,0.497 0.376,0.57 0.408,0.638 0.439,0.689 0.495,0.744 0.543,0.793 0.575,0.822 0.63,0.863 0.672,0.895 0.702,0.913 0.75,0.937 0.793,0.959 0.823,0.971 0.87,0.983 0.917,0.994 1,1 1,1'),
                    });
                });
            }
        });
    }
}
